import {
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  inject,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { TranslateService } from "@ngx-translate/core";

interface MultiSelectOption {
  label: string;
  value: unknown;
  [key: string]: unknown;
}

@Component({
  selector: "app-multi-select",
  templateUrl: "./multi-select.component.html",
  styleUrls: ["./multi-select.component.scss"],
})
export class MultiSelectComponent implements OnChanges {
  @Input() dropdownOptions: MultiSelectOption[] = [];
  translatedOptions: MultiSelectOption[] = [];
  @Input() selectedOptions: any[] = [];
  @Input() styleClass: string = "";
  @Input() panelStyleClass: string = "";
  selectedOption: any[] = [];
  @Output() emitAction = new EventEmitter<any>();

  private readonly translate = inject(TranslateService);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.translate.onLangChange
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.translateOptions());
  }

  ngOnChanges(): void {
    this.translateOptions();
  }

  private translateOptions(): void {
    this.translatedOptions = (this.dropdownOptions ?? []).map((option) => ({
      ...option,
      label: this.translate.instant(option.label),
    }));
  }

  onSelectItem(event: any) {
    this.emitAction.emit(event.value);
  }
}
